import './App.css';
import { Routes, Route } from 'react-router-dom';
import Agendamentos from './pages/clientes/agendamentos/agendamentos';
import CookieConsent from '../src/controlCookies';
import InicioOpcoes from "./pages/clientes/agendamentos/InicioOpcoes";
import ConsultarAgendamentos from "./pages/clientes/agendamentos/consultar-agendamentos";
import Sistema from "./pages/sistema/Sistema";
import Login from "./pages/login";
import SistemaMaster from "./pages/sistema/SistemaMaster";
import ConfirmarExclusao from "./pages/clientes/agendamentos/confirmarExclusao";
import ForgotPassword from "./pages/ForgotPassword";
import ModalMessage from './components/ModalMessage/ModalMessage';
import LoginAdminGeral from "./pages/LoginAdminGeral";
import AdminGeralDashboard from "./pages/admin-geral/Dashboard";
import ClientesMaster from "./pages/admin-geral/ClientesMaster";
import NovoClienteMaster from "./pages/admin-geral/NovoClienteMaster";
import EditarClienteMaster from "./pages/admin-geral/EditarClienteMaster";
import RenovarMensalidade from "./pages/admin-geral/RenovarMensalidade";
import ConfiguracoesAdminGeral from "./pages/admin-geral/Configuracoes";
import PoliticaETermos from './pages/Privacidade';
import Home from './pages/PaginaInicial';

function App() {
  return (
    <>
      <CookieConsent />
      <Routes>
        {/* Página inicial sem slug */}
        <Route path="/" element={<Home />} />

        {/* Telas fixas de login, admin, etc */}
        <Route path="/login" element={<Login />} />
        <Route path="/login-admin-geral" element={<LoginAdminGeral />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/resetar-senha" element={<ForgotPassword />} />
        <Route path="/sistema" element={<Sistema />} />
        <Route path="/sistema-master" element={<SistemaMaster />} />
        <Route path="/admin-geral/dashboard" element={<AdminGeralDashboard />} />
        <Route path="/admin-geral/clientes-master" element={<ClientesMaster />} />
        <Route path="/admin-geral/clientes-master/novo" element={<NovoClienteMaster />} />
        <Route path="/admin-geral/clientes-master/:id/editar" element={<EditarClienteMaster />} />
        <Route path="/admin-geral/clientes-master/:id/renovar" element={<RenovarMensalidade />} />
        <Route path="/admin-geral/configuracoes" element={<ConfiguracoesAdminGeral />} />
        <Route path="/confirmar-exclusao" element={<ConfirmarExclusao />} />
        <Route path="/politica-e-termos" element={<PoliticaETermos />} />

        {/* Rotas de clientes via slug - sempre por último */}
        <Route path="/:slug/agendamentos" element={<Agendamentos />} />
        <Route path="/:slug/consultar-agendamentos" element={<ConsultarAgendamentos />} />
        <Route path="/:slug" element={<InicioOpcoes />} />
      </Routes>
      <ModalMessage />
    </>
  );
}

export default App;
